export default __webpack_public_path__ + "static/media/09-ghidoni.88994dc1.jpg";